import {connect} from 'react-redux';
import React, {Component, useMemo, useState} from 'react';
import CopyButton from '../../cmp/CopyButton';
import CustomCouponModal from './CustomCouponModal';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import {Link} from 'react-router-dom';
import RenderDiscountValue from '../home/components/RenderDiscountValue';
import useToggle from '../../cmp/hooks/useToggle';
import {
    FiChevronDown,
    FiCopy,
    FiEdit,
    FiEdit2,
    FiEdit3,
    FiLink,
} from 'react-icons/fi';
import {IoIosStats} from 'react-icons/io';
import Modal from '../../cmp/Modal';
import LazyRangePicker from '../../cmp/lazy/LazyRangePicker';
import FormGroup from '../../cmp/form/FormGroup';
import BootStrapPagedTable from '../../cmp/BootStrapPagedTable';
import CurrencyNumber from '../../cmp/CurrencyNumber';
import useSwr from 'swr';
import {get} from '../../../api';
import dayjs from '../../../mydayjs';
import RenderCommission from '../../cmp/RenderCommission';

const mapStateToProps = (state) => {
    return {
        apply_discount_on_link: state.settings.apply_discount_on_link,
        my_coupons: state.settings.my_coupons || [],
        integration: state.settings.integration,
        website: state.settings.website,
        noCouponGiven: state.settings.locale_messages.noCouponGiven,
        account_status: state.settings.status,
        ref_code: state.settings.ref_code,
        coupon_change_allowed: state.settings.coupon_change_allowed === undefined ? false : state.settings.coupon_change_allowed
    }
}
function CouponStats(){
    const [dates, setDates] = useState([
        dayjs().startOf('year').toDate(),
        dayjs().toDate(),
    ])
    const url = useMemo(()=>{
        const params = new URLSearchParams()
        params.set('start_date', dayjs(dates[0]).format('YYYY-MM-DD'))
        params.set('end_date', dayjs(dates[1]).format('YYYY-MM-DD'))
        return `/analytics/coupons?${params.toString()}`
    },[dates])
    const {data, isLoading} = useSwr(url,get)

    const columns = useMemo(()=>{
       return [
           {
               title:'Coupon',
               dataIndex:'code'
           },
           {
               title:'Orders',
               dataIndex:'num_orders',
               type:'number',
               render:(record)=><FormattedNumber value={record} />
           }, {
               title:'Volume',
               dataIndex:'subtotal',
               type:'number',
                render:(record)=><CurrencyNumber value={record} />
           }, {
               title:'Earnings',
               dataIndex:'earning',
               type:'number',
               render:(record)=><CurrencyNumber value={record} />
           },
       ]
    },[])
    return <>
        <LazyRangePicker onChange={setDates} startDate={dates[0]} endDate={dates[1]} />
        <BootStrapPagedTable dataSource={data?.coupons || []}
                             loading={isLoading}
                             columns={columns} />
    </>
}

function CouponRef(props) {
    const [show_coupon_modal, toggleShowCouponModal] = useToggle();
    const [editing_coupon, setEditingCoupon] = useState(null);
    const {account_status, my_coupons, coupon_change_allowed,
           noCouponGiven,
    } = props;
    const [stats_visible, toggle] = useToggle()
    const [visibleCount, setVisibleCount] = useState(3)
        return (<div className={'row align-items-center'}>
                <div className={'col'}>
                    <h4 className={'d-flex align-items-center'}><FormattedMessage id={'couponCode'}/>
                        <>
                            <button className="btn p-0 m-0 " onClick={toggle}>
                                <IoIosStats size={22}/>
                            </button>
                        </>
                        {
                            my_coupons.length === 1 && my_coupons[0].discount_value ?
                                <RenderDiscountValue coupon={my_coupons[0]}/> : null
                            }
                    </h4>
                    <p className={'text-muted'}>
                        <FormattedMessage id={'couponCodeSubtitle'} values={{
                            discount_value:
                                Array.isArray(my_coupons) && my_coupons.length >
                                0 ?
                                    <RenderCommission
                                        commission_value={my_coupons[0].discount_value ||
                                            my_coupons[0].discount_amount}
                                        commission_type={my_coupons[0].discount_type}
                                    /> : undefined
                        }}/>
                    </p>
                    <CustomCouponModal onClose={()=>{
                        toggleShowCouponModal()
                        setEditingCoupon(null)
                    }} editing_coupon={editing_coupon}
                                       visible={show_coupon_modal}/>
                    {
                        stats_visible ? <>
                            <CouponStats />
                        </> : <>
                        {
                            my_coupons && my_coupons.length > 0 ? my_coupons.slice(0,visibleCount).map((item) => {
                                const {can_change, discount_value, link} = item;
                                const coupon = ['pending', 'blocked'].indexOf(account_status) < 0 ? item.coupon : item.coupon.replace(/./g, "*")
                                return <div className={'row align-items-center mb-2'} key={String(item.coupon)}>
                                    <div className={'col-auto'}>
                                        {
                                            my_coupons.length > 1 && discount_value &&   <small>
                                                <FormattedMessage id={'couponCode'}/><RenderDiscountValue
                                                coupon={item}/> </small>
                                        }
                                        <h4>{coupon}</h4>
                                        {
                                            can_change && account_status ===
                                            'approved' &&
                                            coupon_change_allowed && (
                                                <div>
                                                    <button className="btn btn-link px-0" onClick={()=>{
                                                        setEditingCoupon(coupon)
                                                        toggleShowCouponModal()
                                                    }}>
                                                        <FormattedMessage id={'changeCoupon'}/>
                                                    </button>
                                                </div>)
                                        }
                                    </div>
                                    {
                                        account_status === 'approved' &&
                                        <div className={'col-auto'}>
                                            <CopyButton text={coupon}/>
                                        </div>
                                    }
                                    <div className="col-auto">
                                        {
                                            link &&
                                            <div>
                                                <CopyButton text={link} title={"Copy Shareable Link"}/>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }) : <p className={`alert alert-info ${!noCouponGiven && 'd-none'}`}>
                                <FormattedMessage id={'noCouponGiven'} values={
                                    {
                                        contact_us: <Link to={'/contact'} className={'alert-link ml-1'}>
                                            <FormattedMessage id={'contactUs'}/>
                                        </Link>
                                    }
                                }/>
                            </p>
                        }
                    {
                        my_coupons && my_coupons.length > visibleCount && <>
                            <button className={'btn btn-link px-0 d-inline-flex'} onClick={()=>{
                                setVisibleCount(my_coupons.length)
                            }}><FormattedMessage id={"View all"} /><FiChevronDown className={"fs-4"} /></button>
                        </>
                    }</>
                    }
                </div>
            </div>
        );
}
//
// function RenderCouponLink({integration, website, coupon, ref_code}) {
//     if (!website) return null
//     const url = getCouponLink(integration, website, coupon, ref_code);
//     return url ? <CopyButton text={url} title={"Copy Shareable Link"}/> : null
// }

export default connect(mapStateToProps)(CouponRef);
